import React from 'react';
import s from './SV.module.scss'
type SVType = {

}

export const SV = (props: SVType) => {
	return (
		<>
			<div>В стадии наполнения</div>
		</>
	);
};